<template>
  <v-card flat>
    <v-card-title class="pl-0 py-2">
      <v-icon v-if="error" color="error" class="mr-2">mdi-close-circle</v-icon>
      Case Type
    </v-card-title>
    <v-card-text class="pl-0">
      <v-btn-toggle v-model="caseType" class="rounded-10">
        <v-btn>
          <v-icon v-if="caseType === 0" color="primary" class="mr-2">
            mdi-check-circle
          </v-icon>
          <v-icon v-if="caseType !== 0" color="secondary" class="mr-2">
            mdi-circle
          </v-icon>
          Surgical (Immediate)
        </v-btn>
        <v-btn>
          <v-icon v-if="caseType === 1" color="primary" class="mr-2">
            mdi-check-circle
          </v-icon>
          <v-icon v-if="caseType !== 1" color="secondary" class="mr-2">
            mdi-circle
          </v-icon>
          Restorative (Final)
        </v-btn>
      </v-btn-toggle>
    </v-card-text>
    <v-fade-transition>
      <span class="error--text" v-if="error">
        {{ this.error }}
      </span>
    </v-fade-transition>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  name: "NewOrderCaseType",

  props: ["value"],

  inject: ["form"],

  data() {
    return {
      error: null
    }
  },

  computed: {
    ...mapGetters(["settings"]),

    caseType: {
      get() {
        if (this.value == true) return 0
        return 1
      },

      set(value) {
        if (value === 0) {
          this.$emit("input", true)
          return
        }
        this.$emit("input", false)
      }
    }
  },

  methods: {
    validate() {
      if (this.caseType === undefined) {
        this.error = "Case Type is Required"
      }
      return this.caseType !== undefined
    }
  },

  created() {
    this.form.register(this)
  }
}
</script>
